export default {
  "content": "<path fill=\"#1371C8\" fill-rule=\"evenodd\" d=\"M4 4c-1.105 0-2 .86-2 1.92v12.16C2 19.14 2.895 20 4 20h16c1.105 0 2-.86 2-1.92V5.92C22 4.86 21.105 4 20 4H4zm10.917 6c0 1.547-1.306 2.8-2.917 2.8-1.611 0-2.917-1.253-2.917-2.8S10.39 7.2 12 7.2c1.611 0 2.917 1.253 2.917 2.8zm-8.75 8.4c0-2.1 2.552-4.2 5.833-4.2s5.833 2.1 5.833 4.2H6.167z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "none",
    "viewBox": "0 0 24 24"
  }
};